/* Shared CampVale cart drawer — used by every page except product.dc.html
   (which renders its own drawer from DC state). Reads the same
   localStorage key so the two stay in sync.

   Cart model: { lights: n, temp } — n is the TOTAL number of lights.
   Pricing auto-bundles greedily: every 3 lights price as a Full Setup ($249),
   a remainder of 2 as a Duo ($199), a remainder of 1 as One-Zone ($119).
   So 4 lights = 249+119, 5 = 249+199, 6 = 2×249, 7 = 2×249+119, …
   Legacy carts { setup, qty } are migrated on read. */
(function () {
  var KEY = 'campvale_cart';
  var UNIT = 119, DUO = 199, FULL = 249;
  var MAX = 9;
  var open = false;

  function toLights(c) {
    if (!c) return 0;
    if (typeof c.lights === 'number') return Math.max(0, Math.min(MAX, c.lights));
    var nl = { one: 1, duo: 2, full: 3 };
    if (c.setup && c.qty) return Math.min(MAX, (nl[c.setup] || 1) * c.qty);
    return 0;
  }
  function bundlePrice(n) {
    var a = Math.floor(n / 3), r = n % 3;
    return a * FULL + (r === 1 ? UNIT : r === 2 ? DUO : 0);
  }
  function bundleLabel(n) {
    if (n <= 0) return '';
    if (n === 1) return 'One-Zone Setup';
    if (n === 2) return 'Duo Setup';
    if (n === 3) return 'Full Setup';
    var a = Math.floor(n / 3), r = n % 3, parts = [];
    if (a) parts.push(a > 1 ? a + '× Full Setup' : 'Full Setup');
    if (r === 1) parts.push('One-Zone');
    if (r === 2) parts.push('Duo');
    return parts.join(' + ');
  }
  function thumbFor(n) {
    return (window.CV?CV.setupCut[Math.max(1,Math.min(3,n))]:'');
  }


  // ---- Shopify cart backend (variant per lights-count; single line, qty 1) ----
  var _cache = null;
  function v2state(cart){
    if(!cart || !cart.items || !cart.items.length) return null;
    var it = cart.items[0];
    var n = parseInt(it.variant_title, 10) || 1;      // "3 Lights / Cool White"
    var temp = /warm/i.test(it.variant_title) ? 'warm' : 'cool';
    return { lights: Math.max(1, Math.min(MAX, n)), temp: temp };
  }
  function read(){ return _cache; }
  function refresh(cb){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(c){ if(_busy){ if(cb) cb(); return; } _cache = v2state(c); syncCount(); if(open) render(); if(cb) cb(); })
      .catch(function(){});
  }
  function variantFor(n,temp){ return (window.CV && CV.variants[temp==='warm'?'warm':'cool'][String(Math.max(1,Math.min(MAX,n)))]); }
  var _busy=false, _pending=null;
  function _done(){ _busy=false; if(_pending){ var p=_pending; _pending=null; writeLights(p[0],p[1]); } else refresh(); }
  function writeLights(n, temp){
    if(_busy){ var tq=temp==='warm'?'warm':'cool'; _pending=[n,temp];
      _cache = n>0 ? {lights:Math.max(1,Math.min(MAX,n)),temp:tq} : null;
      render(); syncCount(); return; }
    _busy=true;
    n=Math.max(0,Math.min(MAX,n));
    var t = temp==='warm'?'warm':'cool';
    _cache = n>0 ? {lights:n,temp:t} : null;   // optimistic
    render(); syncCount();
    fetch('/cart/clear.js',{method:'POST'}).then(function(){
      if(n<1){ cdReset(); _done(); return; }
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:variantFor(n,t),quantity:1}]})})
        .then(function(r){ if(!r.ok) throw 0; })
        .then(function(){ _done(); })
    }).catch(function(){ _done(); });
  }
  function syncCount(){
    var n = toLights(read());
    document.querySelectorAll('.cart-link').forEach(function(el){ el.textContent='Cart ('+n+')'; });
  }
  window.CVCART = { open:function(){ refresh(function(){ setOpen(true); }); setOpen(true); },
                    set:writeLights, refresh:refresh };

  /* ---- cart reserve countdown + leave-warning + trust row (additive) ---- */
  var CD_DUR = 8 * 60, _cdT = 0, _expiring = false;
  var CD_KEY = 'cv-reserve-start';
  function cdRead() { try { return parseInt(localStorage.getItem(CD_KEY) || '0', 10) || 0; } catch (e) { return 0; } }
  function cdWrite(v) { try { if (v) localStorage.setItem(CD_KEY, String(v)); else localStorage.removeItem(CD_KEY); } catch (e) {} }
  /* the reservation clock starts only when the customer OPENS the cart drawer,
     never on add-to-cart. On expiry the cart is emptied back to its initial state. */
  function cdStart() { if (!cdRead()) cdWrite(Date.now()); }
  function cdReset() { cdWrite(0); clearTimeout(_cdT); }
  function cdExpire() {
    if (_expiring) return; _expiring = true;
    cdReset();
    var bar = document.getElementById('cv-reserve');
    if (bar) bar.style.display = 'none';
    _cache = null;
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () { _expiring = false; refresh(); })
      .catch(function () { _expiring = false; render(); syncCount(); });
  }
  function cdTick() {
    clearTimeout(_cdT);
    var el = document.getElementById('cv-cd');
    if (!el) return;
    if (!toLights(read())) { cdReset(); return; }   // empty cart: nothing to reserve
    cdStart();                                      // drawer is open with items -> clock runs
    var s0 = cdRead();
    if (!s0) { return; }
    var left = Math.max(0, CD_DUR - Math.floor((Date.now() - s0) / 1000));
    var bar = document.getElementById('cv-reserve');
    if (left <= 0) { cdExpire(); return; }
    if (bar) bar.style.display = 'flex';
    el.textContent = ('0' + Math.floor(left / 60)).slice(-2) + ':' + ('0' + (left % 60)).slice(-2);
    _cdT = setTimeout(cdTick, 250);
  }
  function fillPay() {
    var pl = document.getElementById('cv-payline'), src = document.getElementById('cv-pay-src');
    if (!pl || !src || !src.querySelector('svg')) return;
    pl.innerHTML = src.innerHTML;
    Array.prototype.forEach.call(pl.querySelectorAll('svg'), function (sv) {
      sv.style.height = '20px'; sv.style.width = 'auto'; sv.style.display = 'block'; sv.style.borderRadius = '2.5px';
    });
  }
  function showWarn() {
    if (document.getElementById('cv-warn')) return;
    var w = document.createElement('div');
    w.id = 'cv-warn';
    w.innerHTML = '<div style="position:fixed;inset:0;z-index:95;background:rgba(10,14,20,0.55);display:flex;align-items:center;justify-content:center;padding:24px;">' +
      '<div style="background:#fff;border-radius:18px;max-width:360px;width:100%;padding:26px 24px;text-align:center;box-shadow:0 24px 70px rgba(0,0,0,0.3);font-family:Archivo,sans-serif;">' +
      '<div style="font:500 21px Newsreader,serif;color:#1D1D1F;">Leave your cart?</div>' +
      '<p style="color:#6E6E73;font-size:14px;line-height:1.6;margin:10px 0 18px;">Your cart is only reserved for a few minutes, your new-customer discount may expire.</p>' +
      '<div data-cv-stay role="button" tabindex="0" style="background:#111;color:#fff;border-radius:11px;padding:13px;font-weight:700;font-size:15px;cursor:pointer;">Keep my cart</div>' +
      '<div data-cv-leave role="button" tabindex="0" style="margin-top:12px;color:#6E6E73;font-size:13.5px;text-decoration:underline;cursor:pointer;">Leave anyway</div>' +
      '</div></div>';
    host().appendChild(w);
  }
  function hideWarn() { var w = document.getElementById('cv-warn'); if (w && w.parentNode) w.parentNode.removeChild(w); }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function host() {
    var h = document.getElementById('cv-drawer-host');
    if (!h) {
      h = document.createElement('div');
      h.id = 'cv-drawer-host';
      document.body.appendChild(h);
    }
    return h;
  }

  function upgradeBlock(n) {
    if (n >= 3) {
      return '<div style="background: #F2F6FA; border-radius: 14px; padding: 14px 18px; display: flex; align-items: center; gap: 11px;">' +
        '<span style="width: 20px; height: 20px; flex: none; border-radius: 99px; background: #33608D; color: #FBFBFD; font-size: 11px; display: flex; align-items: center; justify-content: center;">&#10003;</span>' +
        '<div style="color: #1D1D1F; font: 500 14px Archivo, sans-serif;">Best bundle pricing applied</div></div>';
    }
    if (n === 1) {
      return '<div style="background: #F2F6FA; border-radius: 14px; padding: 15px 16px; display: flex; flex-direction: column; gap: 10px;">' +
        '<div style="color: #33608D; font: 600 10px Archivo, sans-serif; letter-spacing: 2px; text-transform: uppercase;">Add more coverage</div>' +
        '<div data-cv-up="2" role="button" tabindex="0" style="cursor: pointer; display: flex; align-items: center; gap: 14px; padding: 12px 14px; border-radius: 10px; border: 1px solid #DCE3EB; background: #FFFFFF;">' +
          '<div style="flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px;">' +
            '<div style="color: #1D1D1F; font: 500 14px Archivo, sans-serif;">2 Lights</div>' +
            '<div style="color: #9A9AA0; font-size: 12px;">Save $39</div></div>' +
          '<div style="flex: none; color: #33608D; font: 600 12.5px Archivo, sans-serif; border: 1px solid #A9BDD3; padding: 9px 16px; border-radius: 8px; white-space: nowrap;">+ $80</div></div>' +
        '<div data-cv-up="3" role="button" tabindex="0" style="cursor: pointer; position: relative; display: flex; align-items: center; gap: 14px; padding: 13px 14px; border-radius: 10px; background: #FFFFFF; border: 1.5px solid #33608D;">' +
          '<div style="position: absolute; top: -8px; left: 14px; background: #33608D; color: #FBFBFD; font: 700 9px Archivo, sans-serif; letter-spacing: 1.2px; padding: 3px 8px; border-radius: 4px;">BEST VALUE</div>' +
          '<div style="flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; padding-top: 2px;">' +
            '<div style="color: #1D1D1F; font: 500 14px Archivo, sans-serif;">3 Lights</div>' +
            '<div style="color: #33608D; font: 600 12px Archivo, sans-serif;">Save $108</div></div>' +
          '<div style="flex: none; background: #33608D; color: #FBFBFD; font: 600 12.5px Archivo, sans-serif; padding: 10px 18px; border-radius: 8px; white-space: nowrap;">+ $130</div></div>' +
        '</div>';
    }
    return '<div style="background: #F2F6FA; border-radius: 14px; padding: 15px 18px; display: flex; align-items: center; gap: 16px;">' +
      '<div style="flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px;">' +
        '<div style="color: #33608D; font: 600 10px Archivo, sans-serif; letter-spacing: 2px; text-transform: uppercase;">Recommended</div>' +
        '<div style="color: #1D1D1F; font: 500 15px Archivo, sans-serif;">One more light. Just $50.</div>' +
        '<div style="color: #33608D; font: 600 12px Archivo, sans-serif;">Save $69</div></div>' +
      '<div data-cv-up="3" role="button" tabindex="0" style="cursor: pointer; flex: none; background: #33608D; color: #FBFBFD; font: 600 12.5px Archivo, sans-serif; padding: 11px 18px; border-radius: 8px; white-space: nowrap;">Upgrade</div></div>';
  }

  function body(c) {
    var n = toLights(c);
    if (!n) {
      return '<div style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; gap: 12px; padding: 24px;">' +
        '<div style="font: 500 24px Newsreader, serif; color: #1D1D1F;">Your Cart is Empty</div>' +
        '<p style="margin: 0; color: #6E6E73; font-size: 14px; line-height: 1.6; max-width: 280px;">Start with the zone around your RV that needs light first.</p>' +
        '<a href="/products/rv-01-smart-light" style="margin-top: 8px; background: #1D1D1F; color: #FBFBFD; font-weight: 600; font-size: 14px; padding: 12px 30px; border-radius: 8px;">Shop RV-01</a></div>';
    }
    var sub = bundlePrice(n);
    var listTotal = UNIT * n;
    var save = listTotal - sub;
    var temp = c.temp === 'warm' ? 'Warm white' : 'Cool white';

    return '<div style="flex: 1; min-height: 0; overflow-y: auto; padding: 22px 24px; display: flex; flex-direction: column; gap: 22px;">' +
      '<div style="display: flex; background: #F2F3F5; border-radius: 14px; overflow: hidden; min-height: 132px;">' +
        '<div style="width: 116px; flex: none; background: #E8E9ED; display: flex; align-items: center; justify-content: center; padding: 12px;">' +
          '<img src="' + thumbFor(n) + '" alt="" style="max-width: 100%; max-height: 104px; display: block; object-fit: contain;"></div>' +
        '<div style="flex: 1; min-width: 0; padding: 14px 18px 12px; display: flex; flex-direction: column;">' +
          '<div style="display: flex; justify-content: space-between; gap: 12px; align-items: baseline;">' +
            '<span style="color: #1D1D1F; font: 600 14.5px Archivo, sans-serif;">RV-01 Smart Light</span>' +
            '<span style="color: #1D1D1F; font: 500 14.5px Archivo, sans-serif; flex: none;">$' + sub + '</span></div>' +
          '<div style="color: #6E6E73; font-size: 12.5px; padding-top: 4px;">' + esc(bundleLabel(n)) + ' / ' + esc(temp) + '</div>' +
          (save > 0 ? '<div style="color: #33608D; font-size: 12.5px; padding-top: 3px;">You save $' + save + '</div>' : '') +
          '<div style="flex: 1; min-height: 12px;"></div>' +
          '<div style="display: flex; align-items: center; justify-content: space-between; gap: 12px;">' +
            '<div style="display: flex; align-items: center; gap: 13px; color: #494950; font-size: 15px;">' +
              '<span data-cv-qty="-1" role="button" tabindex="0" style="cursor: pointer; user-select: none;">&minus;</span>' +
              '<span style="color: #1D1D1F; font-weight: 500;">' + n + '</span>' +
              '<span data-cv-qty="1" role="button" tabindex="0" style="cursor: pointer; user-select: none;">+</span></div>' +
            '<span data-cv-remove="1" role="button" tabindex="0" style="cursor: pointer; color: #1D1D1F; font: 500 11.5px Archivo, sans-serif; letter-spacing: 1.4px; text-transform: uppercase; border-bottom: 1px solid #1D1D1F; padding-bottom: 2px;">Remove</span></div>' +
        '</div></div>' +
      upgradeBlock(n) +
      '<div style="display: flex; flex-direction: column; gap: 8px;">' +
        ['Free Shipping Worldwide', '30-Day Returns', 'One-to-One Support'].map(function (l) {
          return '<div style="display: flex; align-items: center; gap: 9px; color: #4A4A50; font-size: 13px;"><span style="color: #33608D;">&#10003;</span>' + l + '</div>';
        }).join('') +
      '</div></div>' +
      '<div style="flex: none; border-top: 1px solid #E3E3E8; padding: 18px 24px calc(20px + env(safe-area-inset-bottom, 0px)); display: flex; flex-direction: column; gap: 10px;">' +
        '<div style="display: flex; justify-content: space-between; color: #6E6E73; font-size: 13.5px;"><span>Subtotal</span><span>$' + listTotal + '</span></div>' +
        (save > 0 ? '<div style="display: flex; justify-content: space-between; color: #33608D; font-size: 13.5px;"><span>Bundle savings</span><span>&minus;$' + save + '</span></div>' : '') +
        '<div style="display: flex; justify-content: space-between; color: #6E6E73; font-size: 13.5px;"><span>Shipping</span><span>FREE</span></div>' +
        '<div style="display: flex; justify-content: space-between; align-items: baseline; padding-top: 8px; border-top: 1px solid #E3E3E8;">' +
          '<span style="color: #1D1D1F; font: 500 15px Archivo, sans-serif;">Estimated total</span>' +
          '<span style="color: #1D1D1F; font: 600 19px Archivo, sans-serif;">$' + sub + '</span></div>' +
        '<a href="/checkout" style="background: #1D1D1F; color: #FBFBFD; font-weight: 600; font-size: 14.5px; padding: 14px 26px; border-radius: 8px; text-align: center; margin-top: 4px;">Secure Checkout</a>' +
        '<div style="display:flex;align-items:center;justify-content:center;gap:10px;margin-top:6px;">' +
          '<div style="display:flex;">' +
        '<img src="https://cdn.shopify.com/s/files/1/0745/9782/6638/files/cfa3e165-ca46-473b-99dc-cd1879297791.png?v=1786974124" alt="" style="width:26px;height:26px;border-radius:99px;border:2px solid #FBFBFD;display:block;object-fit:cover;object-position:50% 28%;">' +
        '<img src="https://cdn.shopify.com/s/files/1/0745/9782/6638/files/539db0c4-fc02-4ea5-a7dd-899f1a10912c.png?v=1786974124" alt="" style="width:26px;height:26px;border-radius:99px;border:2px solid #FBFBFD;display:block;object-fit:cover;object-position:50% 28%;margin-left:-9px;">' +
        '<img src="https://cdn.shopify.com/s/files/1/0745/9782/6638/files/85ce96fd-98fe-44ed-be2b-89568ef2ecdb.png?v=1786974124" alt="" style="width:26px;height:26px;border-radius:99px;border:2px solid #FBFBFD;display:block;object-fit:cover;object-position:50% 28%;margin-left:-9px;">' +
        '</div>' +
          '<div style="display:flex;align-items:center;gap:8px;">' +
            '<span style="color:#E8A33D;font-size:11px;letter-spacing:1.5px;">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
            '<span style="font-weight:600;font-size:13.5px;color:#1D1D1F;">900+ Happy Customers</span>' +
          '</div>' +
        '</div>' +

      '</div>';
  }

  function render() {
    var h = host();
    if (!open) { h.innerHTML = ''; return; }
    var c = read();
    var n = toLights(c);
    h.innerHTML =
      '<div data-cv-close="1" style="position: fixed; inset: 0; z-index: 90; background: rgba(12,16,22,0.42);"></div>' +
      '<div id="cv-drawer" style="position: fixed; top: 0; right: 0; bottom: 0; z-index: 91; width: 440px; max-width: 100vw; background: #FBFBFD; box-shadow: -18px 0 46px rgba(20,28,40,0.18); display: flex; flex-direction: column; font-family: Archivo, sans-serif;">' +
        '<div id="cv-reserve" style="flex:none;background:#C5303B;padding:8px 14px;display:' + (n ? 'flex' : 'none') + ';align-items:center;justify-content:center;gap:8px;">' +
          '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" style="flex:none"><circle cx="12" cy="12" r="9" stroke="#fff" stroke-width="2"/><path d="M12 7v5l3.2 2" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>' +
          '<span style="color:#FFFFFF;font-size:12.5px;font-weight:700;letter-spacing:0.4px;">Cart reserved &middot; <span id="cv-cd" style="font-variant-numeric:tabular-nums;">08:00</span></span>' +
        '</div>' +
        '<div style="flex: none; display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; padding: 22px 24px 16px; border-bottom: 1px solid #E3E3E8;">' +
          '<div style="display: flex; flex-direction: column; gap: 3px;">' +
            '<div style="font: 500 22px Newsreader, serif; color: #1D1D1F;">Your Cart</div>' +
            (n ? '<div style="color: #6E6E73; font-size: 12.5px;">' + n + ' light' + (n > 1 ? 's' : '') + ' added</div>' : '') +
          '</div>' +
          '<div data-cv-close="1" role="button" tabindex="0" aria-label="Close" style="cursor: pointer; width: 34px; height: 34px; display: flex; align-items: center; justify-content: center; color: #6E6E73; font-size: 20px; line-height: 1;">&times;</div>' +
        '</div>' + body(c) +
      '</div>';
    var d = document.getElementById('cv-drawer');
    if (d && window.innerWidth <= 640) d.style.width = '100vw';
    if (open) { cdTick(); }
  }

  function setOpen(v) {
    open = v;
    render();
  }

  function act(target) {
    if (!target || !target.closest) return false;
    // nav cart link -> open the drawer instead of navigating
    var link = target.closest('.cart-link') || (target.closest('a[href="#cart"]'));
    if (link) { setOpen(true); return true; }
    if (!open) return false;
    if (target.closest('[data-cv-stay]')) { hideWarn(); return true; }
    if (target.closest('[data-cv-leave]')) { hideWarn(); setOpen(false); return true; }
    if (target.closest('[data-cv-close]')) { if (toLights(read())) showWarn(); else setOpen(false); return true; }
    var q = target.closest('[data-cv-qty]');
    if (q) {
      var c = read();
      var n = toLights(c);
      if (!n) return true;
      var d = parseInt(q.getAttribute('data-cv-qty'), 10);
      writeLights(Math.max(1, n + d), c && c.temp);
      return true;
    }
    if (target.closest('[data-cv-remove]')) {
      writeLights(0, _cache && _cache.temp);
      return true;
    }
    var up = target.closest('[data-cv-up]');
    if (up) {
      var cc = read();
      if (!toLights(cc)) return true;
      writeLights(parseInt(up.getAttribute('data-cv-up'), 10), cc && cc.temp);
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('a');
    if (cta && /^Add (One|Two|Three) Lights?/i.test((cta.textContent || '').trim())) {
      e.preventDefault();
      var w = cta.textContent.trim().match(/^Add (One|Two|Three)/i)[1].toLowerCase();
      writeLights({ one: 1, two: 2, three: 3 }[w], _cache && _cache.temp);
      setOpen(true);
      return;
    }
    if (e.target.closest && e.target.closest('.cart-link')) e.preventDefault();
    act(e.target);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) { if (document.getElementById('cv-warn')) hideWarn(); else if (toLights(read())) showWarn(); else setOpen(false); return; }
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (act(e.target)) e.preventDefault();
  });
  // keep the header count fresh (other tabs, and after DC hydration)
  window.addEventListener('storage', function (e) { if (e.key === KEY) { syncCount(); if (open) render(); } });
  function claimCartLinks(){
    var els=document.querySelectorAll('a,div,span');
    for(var i=0;i<els.length;i++){
      var el=els[i];
      if(el.children.length===0 && /^Cart \(\d+\)$/.test((el.textContent||'').trim()) && el.className.indexOf('cart-link')<0){
        el.className=(el.className?el.className+' ':'')+'cart-link';
        el.style.cursor='pointer';
      }
    }
  }
  function boot() { claimCartLinks(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(boot, 400);
  setTimeout(boot, 1500);
})();
